export const TEXT_SCALES = [100, 115, 130, 150] as const;
export type TextScale = typeof TEXT_SCALES[number];
const STORAGE_KEY = 'hc_text_scale';
let currentScale: TextScale | undefined;

function parseScale(value: string | null): TextScale {
  return TEXT_SCALES.find((scale) => String(scale) === value) ?? 100;
}

export function getTextScale(): TextScale {
  if (currentScale !== undefined) return currentScale;
  try {
    return parseScale(localStorage.getItem(STORAGE_KEY));
  } catch {
    return 100;
  }
}

export function initTextScale(): void {
  document.documentElement.style.setProperty('--message-text-scale', String(getTextScale() / 100));
}

export function setTextScale(scale: TextScale): void {
  currentScale = parseScale(String(scale));
  initTextScale();
  try {
    localStorage.setItem(STORAGE_KEY, String(currentScale));
  } catch {
    // При недоступном хранилище выбор действует до перезагрузки страницы.
  }
}
